import styled from 'styled-components';
import { DesktopFooter as _DesktopFooter, Footer } from '@/components/Footer';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: ${({ theme }) => theme.palette.primary.background};
`;

export const DesktopFooter = styled(_DesktopFooter)`
  max-width: 1000px;
  margin-top: 40px;
  padding: 40px 25px;
  overflow-anchor: none;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: 40px;
  }
`;

export const MobileFooter = styled(Footer)`
  overflow-anchor: none;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-top: 60px;
  }
`;
